import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import { useLiveAccountState } from 'View/live-account/state';
import postLiveAccountAvalaibility from 'Api/live-account/postLiveAccountAvailability';
import { useToast } from 'Store/toast';

import postLiveAccountAvailabilityPayload from './model/request/postLiveAccountAvailabilityPayload';

const usePostLiveAccountAvailability = () => {
  const { t } = useTranslation('live-account');
  const { updateState } = useLiveAccountState();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = postLiveAccountAvailabilityPayload(formData);
      return await postLiveAccountAvalaibility({ payload });
    },
    onSuccess: () => {
      updateState({ errorFields: {} });
    },
    onError: (error) => {
      const errorFields = error?.response?.data?.errorFields;

      if (!isEmpty(errorFields)) return updateState({ errorFields });

      onOpenToast({
        status: 'error',
        title: t('inlineErrorTitle'),
        duration: 5,
        alwaysShow: false,
      });
    },
  });
};

export default usePostLiveAccountAvailability;